import { render, staticRenderFns } from "./fast-games.vue?vue&type=template&id=17ac3f44"
import script from "./fast-games.vue?vue&type=script&lang=js"
export * from "./fast-games.vue?vue&type=script&lang=js"
import style0 from "./fast-games.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/fast-games.vue
// module id = mKQe
// module chunks = 0